import React from 'react';
import { Box, Container, Typography, Grid, Paper, Button } from '@mui/material';
import { FaYandex, FaStar, FaCalendarCheck } from 'react-icons/fa';

const Reviews = () => {
  const reviewLinks = [
    {
      id: 'yandex',
      icon: <FaYandex size={32} />,
      label: 'Яндекс.Карты',
      description: 'Читайте отзывы клиентов и оставляйте свои',
      url: 'https://yandex.ru/maps/user/ywrnx22zcvjgb2vvx5t6e8qmgr',
      color: '#FF3B30',
      badge: '4.9 ★',
    },
    {
      id: 'yandex2',
      icon: <FaYandex size={32} />,
      label: 'Яндекс.Карты (2)',
      description: 'Ещё один профиль с отзывами',
      url: 'https://yandex.ru/maps/user/zgvx5724p5h3j8c9kg0djxjeqw',
      color: '#FF3B30',
      badge: '5.0 ★',
    },
    {
      id: 'yclients',
      icon: <FaCalendarCheck size={32} />,
      label: 'YCLIENTS',
      description: 'Отзывы на платформе записи',
      url: 'https://n893698.yclients.com/company/833095/about?o=&previousStepUrl=%2Fcompany%2F833095%2Fpersonal%2Fmenu%3Fo%3D',
      color: '#6C3B8A',
      badge: 'Онлайн-запись',
    },
  ];

  return (
    <Box
      id="reviews"
      sx={{
        py: { xs: 6, md: 8 },
        background: `
          radial-gradient(circle at 10% 20%, rgba(201,161,74,0.08) 0%, transparent 30%),
          radial-gradient(circle at 90% 80%, rgba(20,36,95,0.06) 0%, transparent 30%),
          linear-gradient(135deg, #f3f3f1 0%, #ecece9 100%)
        `,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          textAlign="center"
          gutterBottom
          sx={{
            color: '#14245f',
            mb: 1.5,
            fontFamily: '"Playfair Display", serif',
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.8rem' },
          }}
        >
          Отзывы о нас
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            maxWidth: 640,
            mx: 'auto',
            mb: 5,
            color: '#667085',
            lineHeight: 1.8,
          }}
        >
          Посмотрите, что говорят наши гости, и оставьте свой отзыв.
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {reviewLinks.map((item) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.id}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  background: 'rgba(255,255,255,0.85)',
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(255,255,255,0.5)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.04)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 16px 40px rgba(0,0,0,0.08)',
                    borderColor: item.color,
                  },
                }}
              >
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: `${item.color}14`,
                    color: item.color,
                    mb: 2,
                  }}
                >
                  {item.icon}
                </Box>

                {item.badge && (
                  <Box
                    sx={{
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 999,
                      backgroundColor: item.color,
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 700,
                      mb: 1,
                    }}
                  >
                    {item.badge}
                  </Box>
                )}

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: '#14245f',
                    mb: 1,
                  }}
                >
                  {item.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 14,
                    color: '#667085',
                    mb: 2,
                    flex: 1,
                  }}
                >
                  {item.description}
                </Typography>

                <Button
                  variant="outlined"
                  endIcon={<FaStar size={16} />}
                  href={item.url}
                  target="_blank"
                  sx={{
                    borderRadius: 999,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderColor: item.color,
                    color: item.color,
                    '&:hover': {
                      backgroundColor: item.color,
                      color: '#fff',
                      borderColor: item.color,
                    },
                  }}
                >
                  Смотреть отзывы
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <Typography
            sx={{
              fontSize: 13,
              color: '#667085',
            }}
          >
            Ваше мнение важно для нас! ❤️
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Reviews;